import { graphql } from "relay-runtime"

export const deApproveAndGenerateCarePlanDocumentMutation = graphql`
  mutation deApproveAndGenerateCarePlanDocumentMutation(
    $input: De_approveAndGenerateCarePlanDocumentInput!
    $connections: [ID!]!
  ) {
    approveAndGenerateCarePlanDocument: de_approveAndGenerateCarePlanDocument(input: $input) {
      carePlanSummary @prependNode(connections: $connections, edgeTypeName: "De_carePlanSummaryEdge") {
        id
        treatmentPlan {
          title
          followUpTreatment
          recommendedTreatment
          from
          to
        }
        fileId
        progressNoteId
        signedBy
        signedAt
        updatedAt
        createdAt
        updatedBy
        createdBy
        fileMetadata {
          documentType
          extension
          lengthInKilobytes
        }
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
